/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "e6b6ab412060b4f5f1b452972ca64817a6ac439d";
